import _ from 'lodash';

/**
 * The application model.
 */
const ApplicationModel = (data = {}) =>
  _.defaults(data, {
    area: "",
    name: "",
    image: "",
    condition: "",
    purchased_date: "",
    purchased_cost: 0,
    current_cost: 0,
    model: "",
    other_area: "",
    other_line_item_name: ""
  });

export default ApplicationModel;
